// extracted by mini-css-extract-plugin
module.exports = {"btn":"_2W-X9t3sQjuF-uXnoWIWHF","icon":"_3bxoTh4bVwoQWS3IMBMYcz"};